import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 400,
    height: "min-content",
  },
  content: {
    width: "100%",
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "40px",
    alignItems: "center",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
    height: "100%",
    borderRadius: theme.spacing(1),
    border: `1px solid ${grey[300]}`,
  },
  avatar: {
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    width: "100%",
  },
  submit: {
    backgroundColor: theme.palette.primary.main,
    marginTop: 8,
    height: 40,
    width: 135,
  },
  submitDisabled: {
    backgroundColor: "rgba(41, 121, 255, 0.5) !important",
    color: `${theme.palette.common.white} !important`,
  },
  loginIcon: {
    marginLeft: 10,
  },
  field: {
    width: 352,
    height: 48,
  },
  signInText: {
    fontWeight: 500,
    fontStyle: "normal",
    fontSize: 24,
    lineHeight: "24px",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  actions: {
    padding: theme.spacing(3, 0, 3),
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
  },
  signInLink: {
    color: theme.palette.primary.main,
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "14px",
    marginTop: "auto",
    marginBottom: "auto",
  },
  buttonText: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  alert: {
    width: 352,
    height: 95,
    marginTop: theme.spacing(3),
  },
}));

export default useStyles;
